import { render, staticRenderFns } from "./AdminSideNav.vue?vue&type=template&id=3c9bd9f0&scoped=true&"
import script from "./AdminSideNav.vue?vue&type=script&lang=js&"
export * from "./AdminSideNav.vue?vue&type=script&lang=js&"
import style0 from "./AdminSideNav.vue?vue&type=style&index=0&id=3c9bd9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9bd9f0",
  null
  
)

export default component.exports